import type { App, InjectionKey } from 'vue';
import { inject } from 'vue';

import type Avo from '../Avo';

export const PLUGIN_KEY = Symbol('avo') as InjectionKey<
  typeof Avo & {
    install: (app: App) => void;
    flushAmplitude: () => void;
  }
>;

export function useAvo() {
  const avo = inject(PLUGIN_KEY);

  if (!avo) {
    throw new Error('Avo plugin not installed. Make sure to call app.use(avoPlugin) before using useAvo()');
  }

  return avo;
}
